import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { widgetLoadingIdSelector } from 'app/store/selectors/widgets';
import DashboardLayout from 'app/pages/Project/ProductionManagement/Dashboards/DashboardLayout/DashboardLayout';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
import classes from 'app/pages/Project/ProductionManagement/Dashboards/DashboardWidgets/styles.scss';
import CostsWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/CostsWidget/CostsWidget';
import GlobalStatusWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/GlobalStatusWidget/GlobalStatusWidget';
import GlobalCostsWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/GlobalCostsWidget/GlobalCostsWidget';
import StatusWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/StatusWidget/StatusWidget';
import WidgetContainer from '../Widgets/WidgetContainer/WidgetContainer';
const DashboardWidgets = (props) => {
    const { widgets, allEpisodes, stepProjects, progressionStatus, setDashboardLayout, dashboardLayout, nested, allLayouts, activeEpisodesByWidget, setActiveEpisodesByWidget, saveDashboardLayoutLocally, } = props;
    const widgetLoadingId = useSelector(widgetLoadingIdSelector);
    const getWidgetConfigRecursively = (widget) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const widgetHasParent = Boolean(widget.parent);
        if (!widgetHasParent)
            return {
                episodes: (_b = (_a = widget.config) === null || _a === void 0 ? void 0 : _a.episodes) !== null && _b !== void 0 ? _b : undefined,
                steps: (_d = (_c = widget.config) === null || _c === void 0 ? void 0 : _c.steps) !== null && _d !== void 0 ? _d : [],
                assetType: (_e = widget.config) === null || _e === void 0 ? void 0 : _e.assetType,
            };
        const widgetParent = widgets.find((wid) => wid.id === widget.parent);
        if (widgetParent) {
            const { episodes = [], steps = [], assetType = null } = getWidgetConfigRecursively(widgetParent);
            const config = widget.config;
            return {
                episodes: ((_f = config.episodes) === null || _f === void 0 ? void 0 : _f.length) ? config.episodes : episodes,
                steps: ((_g = config.steps) === null || _g === void 0 ? void 0 : _g.length) ? config.steps : steps,
                assetType: config.hasOwnProperty('assetType') ? config.assetType : assetType,
            };
            // if (!widget.config.steps?.length) {
            //   const { episodes = [], steps = [], assetType = null } = getWidgetConfigRecursively(widgetParent)
            //   return { episodes: widget.config.episodes?.length ? widget.config.episodes : episodes, steps, assetType }
            // }
            // if (widget.config.steps?.length) {
            //   const { episodes = [], assetType } = getWidgetConfigRecursively(widgetParent)
            //   return {
            //     episodes: widget.config.episodes?.length ? widget.config.episodes : episodes,
            //     steps: widget.config.steps,
            //     assetType,
            //   }
            // }
        }
    };
    const onLayoutChange = (newLayouts) => {
        saveDashboardLayoutLocally(newLayouts);
    };
    function generateDOM() {
        return dashboardLayout.map((layout) => {
            const widget = widgets.find((wid) => wid.id === layout.i);
            if (!widget)
                return;
            const widgetIsContainer = (widget === null || widget === void 0 ? void 0 : widget.widgetType) === WIDGET_TYPES.CONTAINER;
            const childsWidgets = widgets.filter((wid) => wid.parent === widget.id);
            const childsWidgetsIds = childsWidgets.map((wid) => wid.id);
            const childLayout = allLayouts.filter((lay) => childsWidgetsIds.includes(lay.i));
            const isLoading = widgetLoadingId === widget.id;
            const containerHasEpisodeWidget = widgetIsContainer &&
                childsWidgets.some((wid) => [WIDGET_TYPES.CONTAINER, WIDGET_TYPES.EPISODE_COSTS, WIDGET_TYPES.EPISODE_STATUS].includes(wid.widgetType));
            const container = (_jsx("div", { className: cx(classes.widgetContainer, isLoading && classes.blur), children: _jsx(WidgetContainer, { widget: widget, allEpisodes: allEpisodes, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, isLoading: isLoading, displayActionButton: containerHasEpisodeWidget, children: _jsx("div", { children: _jsx(DashboardWidgets, { dashboardLayout: childLayout, allLayouts: allLayouts, setDashboardLayout: setDashboardLayout, nested: true, widgets: widgets, allEpisodes: allEpisodes, stepProjects: stepProjects, progressionStatus: progressionStatus, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, saveDashboardLayoutLocally: saveDashboardLayoutLocally }) }) }) }, layout.i));
            // sub container
            if (widgetIsContainer && nested && widget.parent) {
                return container;
            }
            // container
            if (widgetIsContainer && !nested && !widget.parent) {
                return container;
            }
            const { episodes: displayedEpisodes, steps, assetType } = getWidgetConfigRecursively(widget);
            // console.log('WIDGET HERE', widget, displayedEpisodes)
            const taskWidget = (_jsx("div", { children: _jsx(StatusWidget, { allEpisodes: allEpisodes, steps: steps, assetType: assetType, displayedEpisodes: displayedEpisodes, widget: widget, stepProjects: stepProjects, progressionStatus: progressionStatus, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget }) }, layout.i));
            const costsWidget = (_jsx("div", { children: _jsx(CostsWidget, { steps: steps, allEpisodes: allEpisodes, displayedEpisodes: displayedEpisodes, widget: widget, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget }) }, layout.i));
            const globalStatusWidget = (_jsx("div", { children: _jsx(GlobalStatusWidget, { steps: steps, widget: widget, stepProjects: stepProjects, progressionStatus: progressionStatus }) }, layout.i));
            const globalCostsWidget = (_jsx("div", { children: _jsx(GlobalCostsWidget, { steps: steps, widget: widget }) }, layout.i));
            // widget with no parent
            if (!widgetIsContainer && !props.nested && !widget.parent) {
                switch (widget.widgetType) {
                    case WIDGET_TYPES.EPISODE_STATUS:
                        return taskWidget;
                    case WIDGET_TYPES.EPISODE_COSTS:
                        return costsWidget;
                    case WIDGET_TYPES.GLOBAL_STATUS:
                        return globalStatusWidget;
                    case WIDGET_TYPES.GLOBAL_COSTS:
                        return globalCostsWidget;
                    default:
                        return _jsx(_Fragment, {});
                }
            }
            // nested widget (= child of a container)
            if (!widgetIsContainer && props.nested) {
                switch (widget.widgetType) {
                    case WIDGET_TYPES.EPISODE_STATUS:
                        return taskWidget;
                    case WIDGET_TYPES.EPISODE_COSTS:
                        return costsWidget;
                    case WIDGET_TYPES.GLOBAL_STATUS:
                        return globalStatusWidget;
                    case WIDGET_TYPES.GLOBAL_COSTS:
                        return globalCostsWidget;
                    default:
                        return _jsx(_Fragment, {});
                }
            }
        });
    }
    return (_jsx(DashboardLayout, { layout: dashboardLayout, nested: nested, onLayoutChange: onLayoutChange, children: generateDOM() }));
};
export default DashboardWidgets;
